<template>
   <div role="tablist">
    <template v-for="(grp,grp_index) in groups">
      <b-card no-body class="mb-1" :key="grp_index">
        <b-card-header
          header-tag="header"
          class="p-2"
          role="tab"
          v-b-toggle="`collapse_${grp_index}`"
          @click="toggle_collapse(grp_index)"
        >
          <b-container fluid>
            <b-row align-v="center">
                <b-col cols="auto" class="mr-auto"><h6 class="mb-0">Condition {{grp_index + 1}}</h6></b-col>
                <b-col cols="auto" class="pr-0">
                    <button class="btn btn-xs btn-purple-outline btn-radius btn-purple-round" @click.stop="delete_group(grp_index)">
                        <i class="fal fa-trash-alt"></i>
                    </button>
                </b-col>
            </b-row>
          </b-container>

        </b-card-header>
        <b-collapse :id="`collapse_${grp_index}`" visible role="tabpanel">
          <b-card-body>
            <div class="row">
              <div
                class="form-group col-md-12"
                v-for="(rule,rule_index) in grp.rules"
                :key="rule_index"
              >

                <ac-rule :rule="rule" ref="rules" :groupInx="grp_index" :ruleInx="rule_index"
                         :hasCondition="rule_index !== grp.rules.length - 1"
                         :label="`Sub Condition - ${rule_index + 1}`"
                         @update:rule="on_update_rule"
                         @delete="delete_rule"></ac-rule>
              </div>
              <button class="btn btn-outline-primary ml-3 mt-3" @click="add_rule(grp_index)">+ Add Subcondition</button>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

       <div
          v-if="grp_index !== groups.length - 1"
          :key="`condition_${grp_index}`"
          class="d-flex justify-content-center mb-3 mt-3"
        >
            <b-button-group>
                <b-button
                    :variant="grp.condition == 'And' ? 'primary':'light'"
                    @click.stop="grp.condition = 'And'"
                >And</b-button>
                <b-button
                    :variant="grp.condition == 'Or' ? 'primary':'light'"
                    @click.stop="grp.condition = 'Or'"
                >Or</b-button>
            </b-button-group>
        </div>
    </template>

    <b-row class="justify-content-md-center mt-4">
        <b-col cols="12" md="auto">
            <button class="btn btn-primary justify-content-center" @click="add_group">Add Condition</button>
        </b-col>
    </b-row>
  </div>
</template>
<script>
import acRule from "./ac-automation-rule";
export default {

    components: {
        acRule
    },

    name: 'ac-automate-condition-list',

    props: {
        rule_json: {
            type: Object,
            required: false,
            default: () => ({})
        },

        prefill_data: {
            type: Array,
            required: false,
            default: () => ([])
        }
    },

    data() {
        return {
            groups: [],
            query_builder_output: [], // Not used
            query_build_json: {
                condition: "Or",
                rules: []
            }
        };
    },

    methods: {
      on_update_rule({ groupInx, ruleInx, rule }) {
        const updated_rule = { ...this.groups[groupInx].rules[ruleInx], ...rule }
        this.groups[groupInx].rules.splice(ruleInx, 1, updated_rule)
      },
      /**
       * Invoke on click of add group button
       * @function add_group - To add a new group
       */
      add_group() {
        const query_build_json = Object.assign({}, this.query_build_json);
        const rule_json = Object.assign({}, this.rule_json);
        query_build_json["rules"] = [{ ...rule_json }];
        this.groups.push(query_build_json);
      },

      /**
       * Invoke on click of delete group button
       * @function delete_group - To delete the added group
       */
      delete_group(groupInx) {
        this.groups.splice(groupInx, 1);
      },

      /**
       * Invoke on click of add rule button
       * @function add_rule - To add a new section for group
       * @param
       */
      add_rule(grp_index) {
        const rule_json = Object.assign({}, this.rule_json);
        const rules = JSON.parse(JSON.stringify(this.groups[grp_index]["rules"]));
        this.groups[grp_index]["rules"] = [...rules, rule_json];
      },

      /**
       * Not using
       * @function get_query
       */
      async get_query() {
        let rules = this.$refs.rules || [];
        const groups_list = [...this.groups];
        const final_query_list = [];
        groups_list.map((item, index) => {
          var final_query_json = { rules: [] };
          final_query_json["condition"] = item.condition;
          rules.map((ruleItem, ruleinx) => {
            if (rules[ruleinx].groupInx == index)
              final_query_json["rules"].push(ruleItem.rule);
          });
          final_query_list.push(final_query_json);
        });

        return {
            conditions: final_query_list
        };
      },
      /**
       * Invoke on click of close button
       * @function delete_rule - To delete the added section
       */
      delete_rule({ ruleInx, groupInx }) {
        this.groups[groupInx].rules.splice(ruleInx, 1);
        if (!this.groups[groupInx].rules.length) this.groups.splice(groupInx, 1);
      }
  },
  created() {
    var groups = [];
    if (this.prefill_data.length) {
      var avail_data = [...this.prefill_data];
      avail_data.map(item => {
        var rulesList = [];
        let { condition, rules } = item;
        let { keys, operators, controls } = this.rule_json;
        rulesList = rules.map(rl => {
          return { ...rl, keys, operators, controls };
        });
        groups.push({ condition, rules: rulesList });
      });
    }
    this.groups = [...groups];
  },
  mounted() {}
}
</script>
